module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-03"
  }, [_c('v-container', {
    attrs: {
      "pb-5": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "mt-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": "",
      "lg1": ""
    }
  }, [_c('image-app', {
    attrs: {
      "imaSize": 80,
      "imaSrc": "design/banco3-1-1",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": "",
      "md8": "",
      "lg8": ""
    }
  }, [_c('h1', {
    staticClass: "animated fadeInLeft"
  }, [_c('span', {
    staticClass: "davi-curs font-red"
  }, [_vm._v("\n            En resumen,\n          ")]), _vm._v("\n          el patrimonio se puede definir en la siguiente fórmula:\n        ")]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Fórmula del patrimonio',
      "videoEmbed": "ADMINISTRACIONDINERO47FormulaPatrimonio.mp4"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "animated fadeInUp dura_1",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "mt-2": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md10": "",
      "text-xs-center": ""
    }
  }, [_c('p', {
    staticClass: "formula-patrimonio"
  }, [_c('span', {
    staticClass: "font-red davi-curs"
  }, [_vm._v("Patrimonio =")]), _vm._v("\n           Propiedades +\n           "), _c('span', {
    staticClass: "font-red davi-curs"
  }, [_c('tooltip', {
    staticClass: "tip font-red davi-curs",
    attrs: {
      "texto": "ingresos",
      "tooltip": "Es el dinero que se destina para comprar algo que genere ingresos futuros. Es un plan en el que se trazan objetivos económicos y se eligen formas de inversión (negocios, bienes raíces, etc.) para alcanzarlos, así como estrategias de protección o cubrimiento de riesgos, especialmente aquellos relacionados con la persona que ejecuta el plan.",
      "textPos": "text-right"
    }
  })], 1), _vm._v("\n            + Ahorro "), _c('span', {
    staticClass: "font-red"
  }, [_vm._v("– Deudas")])])])], 1), _vm._v(" "), (_vm.inversion) ? _c('v-layout', {
    staticClass: "adorn-bottom animated fadeInDown light-dark-int ",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md7": ""
    }
  }, [_c('p', {
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n          Es el dinero que se destina para comprar algo que genere ingresos futuros. "), _c('br'), _c('br'), _vm._v("\n          Es un plan en el que se trazan objetivos económicos y se eligen formas de inversión\n          (negocios, bienes raíces, etc.) para alcanzarlos, así como estrategias de protección o\n          cubrimiento de riesgos, especialmente aquellos relacionados con la persona que ejecuta el plan.\n        ")])])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ae69f9e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-47.vue
// module id = 1019
// module chunks = 1